<template>
  <ModalDialog
    ref="dialog"
    :title="title"
    icon="fa-box"
    sizeClass="modal-med"
    :submitting="submitting"
    :submitTitle="submitTitle"
    :submitDisabled="submitDisabled"
    :showSubmit="true"
    @closed="onClosed"
    @submitted="onSubmitted">

    <LoadingPanel :loading="loading" :loadingError="loadingError" />
    <FormGroup v-bind:form="dialogForm" v-if="!loading">
      <NotificationBar type="info">
        <NotificationBarTitle>Glass Block Creation</NotificationBarTitle>
        <ul>
          <li>This will <strong>not</strong> create any additional sheets in inventory.</li>
          <li>Creating blocks manually simply groups loose sheets together into a block.</li>
          <li>If additional sheets are required, please create a manual stock transaction to add them first.</li>
        </ul>        
      </NotificationBar>

      <ContentTitle>Item Details</ContentTitle>
      <FormRow label="Stock">
        <FormInputStockCode :stockType="InventoryStockTypes.glass" v-model="item.stockId" field="stockId" />
      </FormRow>
      <Spinner v-if="loadingStock" />
      <div v-if="hasStockSelected && hasStockData">
        <FormRow label="Size">
          <FormSelect v-model="item.glassLevelId" :options="glassLevelLookup" field="glassLevelId" />
        </FormRow>
        <FormRow label="Supplier">
          <ContactSearchableSelect v-model="item.contactId" field="contactId" />
        </FormRow>
        <FormRow label="Batch Number">
          <FormInputText v-model="item.referenceCode" field="referenceCode" />
        </FormRow>
        <FormRow label="Sheet Quantity">
          <FormInputText type="number" v-model="item.sheetQuantity" field="sheetQuantity" />
        </FormRow>
      </div>      
    </FormGroup>
  </ModalDialog>
</template>


<script>
import _ from 'lodash'
import { v4 as uuidv4 } from 'uuid'

import form from '@/mixins/form'

import ModalDialog from '@/components/modalDialog.vue'
import ModalDialogMixin from '@/mixins/modalDialog'

import FormInputStockCode from '@/modules/inventory/components/formInputStockCode.vue'
import ContactSearchableSelect from '@/modules/contacts/components/contactSearchableSelect.vue'

import { InventoryStockTypes } from '@/store/types'

export default {
  name: 'GlassBlockAddDialog',
  mixins: [form, ModalDialogMixin],
  components: {
    ModalDialog,
    FormInputStockCode,
    ContactSearchableSelect
  },
  props: {
  },
  data() {
    return {
      loading: false,
      loadingError: '',
      loadingStock: false,
      dialogForm: {},
      item: {
        stockId: null,
        contactId: null,
        glassLevelId: null,
        referenceCode: '',
        sheetQuantity: 0
      },
      stockData: {},
      stockList: [],
      glassLevelLookup: [],
      submitting: false
    };
  },
  watch: {
    'item.stockId': {
      handler(newVal, oldVal) {
        this.item.glassLevelId = null
        this.requestStockData()
      }
    }
  },
  computed: {
    title() {
      return 'New Glass Block'
    },
    submitTitle() {
      return 'Create'
    },
    submitDisabled() {
      return !this.hasStockSelected
    },
    hasStockSelected() {
      return !!this.item.stockId
    },
    hasStockData() {
      return this.stockData && this.stockData.id
    },
  },
  created() {
    this.InventoryStockTypes = InventoryStockTypes
    
  },
  mounted() {
    this.requestData()
  },
  methods: {
    show(options = {}) {
      // Reset form
      this.dialogForm = { }

      return ModalDialogMixin.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(false)
    },
    onSubmitted() {
      this.submitting = true

      this.$apiService.inventoryService.createGlassBlock(this.item)
      .then(response => {
        this.submitting = false
        this.successToast(`Glass Block ${response.data.barcode} created`)
        this.modalClosed(true)
        this.hide()
      })
      .catch(err => {
        this.submitting = false
        this.$data.dialogForm = this.processFormResponse(err)
      })
    },
    requestStockData() {
      this.loadingStock = true

      this.$apiService.inventoryService.getStock(this.item.stockId)
      .then(response => {
        this.stockData = response.data

        // Build the list of glass levels
        // Build the glass size list
        this.glassLevelLookup = []
        this.glassLevelLookup = this.stockData.glassSizeList.reduce((list, glassSize) => {
          if(!glassSize.isActive || glassSize.glassLevels.length == 0)
            return list
          list.push({
            name: `${glassSize.height}x${glassSize.width}`,
            children: glassSize.glassLevels.filter(glassLevel => glassLevel.isActive && !glassLevel.isOffcut).map(glassLevel => {
              let levelName = `${glassLevel.height} x ${glassLevel.width}`

              return {
                id: glassLevel.id,
                value: glassLevel.id,
                name: levelName,
                width: glassLevel.width,
                height: glassLevel.height,
                isOffcut: glassLevel.isOffcut,
                barcode: glassLevel.barcode,
                inventoryBin: glassLevel.inventoryBin,
                offcutComments: glassLevel.offcutComments,
                grainDirection: glassSize.grainDirection,
                qtyOnHand: glassLevel.qtyOnHand
              }
            })
          })
          return list
        }, [])
      })
      .catch(err => {
        this.loadingError = this.processFormResponse(err).errorMessage
      })
      .finally(() => {
        this.loadingStock = false
      })
    },
  }
}
</script>